import React, {useState} from 'react'
import Navbar from './Navbar';

import { Hidden } from '@material-ui/core';
import Cajon from './Cajon';
import VistaCentroCosto_UOrg from '../pages/VistaCentroCosto_UOrg';


const ContenedorVistaCentroCosto_UOrg = () => {

    const [abrir, setAbrir] = useState(false)

    const accionAbrir = () => {
        setAbrir(!abrir)
    }

  return (
    <div> 
        <Navbar accionAbrir={accionAbrir} />
            <Hidden xsDown>
                <Cajon
                    variant="permanent"
                    open={true}
                />
            </Hidden>
            <Hidden smUp>
                <Cajon
                    variant="temporary"
                    open={abrir}
                    onClose={accionAbrir}
                />
            </Hidden>
        <div style={{display: 'flex', justifyContent: 'center'}}>
            <VistaCentroCosto_UOrg />
        </div>
    </div>
  )
}

export default ContenedorVistaCentroCosto_UOrg